'use client'
export { FlatList } from 'react-native'
